import { ColoredDot, Flex, Table, Th, Tr } from 'styling/GlobalStyles'
import { Td } from 'components/Td/Td'
import { ArrowLeft } from 'assets/icons/ArrowLeft'
import { formatDateWithTime, formatParams } from 'utils/helpers'
import { useCallback, useRef, useState } from 'react'
import usePaginate from 'hooks/usePaginate'
import { Title } from 'components/Dashboard/Title'
import {
  DashboardModalArrow,
  DashboardModalContainer,
  DashboardModalContent,
  DashboardModalWrapper,
} from 'pages/Dashboard/Dashboard.styled'
import { InfoIcon } from 'assets/icons/InfoIcon'

export const SuggestionsModal = ({ closeModal }) => {
  const [params, setParams] = useState({ page: 1, limit: 20 })
  const [total, setTotal] = useState(0)
  const [list, setList] = useState([])
  const [loading, setLoading] = useState(false)
  const observer: any = useRef()
  const parserFunction = (data) => {
    setTotal(data.totalCount)
    return data.data
  }

  const lastPostElementRef = useCallback(
    (node) => {
      if (loading) return
      if (observer.current) observer.current.disconnect()

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          setParams((prev: any) => {
            const copy = structuredClone(prev)
            copy.page = copy.page + 1
            return copy
          })
        }
      })

      if (node) observer.current.observe(node)
    },
    [loading],
  )

  usePaginate(
    'hr/dashboard/ai-suggestions',
    formatParams(params),
    null,
    parserFunction,
    setList,
    null,
    null,
    null,
    true,
    null,
    setLoading,
  )

  return (
    <DashboardModalWrapper>
      <DashboardModalContainer style={{ width: screen.availWidth < 500 ? '100%' : '60vw' }}>
        <Flex width='100%' gap='1rem'>
          <DashboardModalArrow onClick={closeModal}>
            <ArrowLeft />
          </DashboardModalArrow>

          <Title
            center
            mainIcon={<InfoIcon />}
            height={'fit-content'}
            title='Notifications'
            color='#FF4F46'
            rightSide={<h2 style={{ color: '#FF4F46' }}>{total}</h2>}
          />
        </Flex>

        <DashboardModalContent width='100%'>
          <Table width='100%' height='100%' modal={true}>
            <Th minWidth={0}>
              <Td w='80%' noTooltip text={''} />
              <Td w='20%' noTooltip text={''} />
            </Th>
            {list?.map((n, i) => (
              <Tr key={i} minWidth={0} ref={list.length === i + 1 ? lastPostElementRef : null}>
                <Td w='80%' text={n.suggestions} />
                <Td w='20%' options text={formatDateWithTime(n.date)} />
              </Tr>
            ))}
          </Table>
        </DashboardModalContent>
      </DashboardModalContainer>
    </DashboardModalWrapper>
  )
}
